import BackButton from "../../components/back-button/BackButton";
import styles from "./Confirm.module.css";
import Separator from "../../components/separator/Separator";
import { useTranslation } from "react-i18next";
import { PatternlibIcon } from "@liebherr/patternlib-react";

const Confirm = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <BackButton preventGoingBack={false} url="/" />
      <Separator></Separator>
      <div className={styles.icon}>
        <PatternlibIcon
          icon-name="checkmark"
          size="32px"
          color="white"
        ></PatternlibIcon>
      </div>
      <Separator space="xxs"></Separator>
      <h2>{t("confirm.title")}</h2>
    </div>
  );
};

export default Confirm;
